export class ViewPendingUtilityBaseRate {
	public id: number;
	public serviceTypeId: string;
	public serviceTypeName: string;
	public stateId: string;
	public stateLong: string;
	public utilityId: string;
	public utilityName: string;
	public rateClass: string;
	public zone: string;
	public effectiveDate: Date;
	public baseRate: number;
	public demandCharge: number;
	public customerCharge: number;
	public adjustmentCharge: number;
	public originalIsHighDeviation: boolean;
	public originalNotWithinThreshold: boolean;
	public originalIsDuplicate: boolean;
	public isUtilityBaseRateDuplicate: boolean;
	public isPendingUtilityBaseRateDuplicate: boolean;

	constructor(viewPendingUtilityBaseRate?: ViewPendingUtilityBaseRate) {
		Object.assign(this, viewPendingUtilityBaseRate);
	}
}
